export enum QuoteOrigin {
  ADVANCED_BOOKING = "ADVANCED_BOOKING",
  ALLOTMENT = "ALLOTMENT",
  SEARCH = "SEARCH",
  MANUAL = "MANUAL",
  CARGO_CONNECT = "CARGO_CONNECT",
}
